/** @format */
import { api } from 'utility';
import {
  getShebaServiceUrl,
  getCardServiceUrl as getCardURL,
 
} from 'URLs';

const source = api.cancelToken;
let cancelToken;
export function getShebaService(params) {
  if (cancelToken) {
    cancelToken.cancel('cancelToken');
  }
  cancelToken = source.source();
  return api.get(getShebaServiceUrl(), { params, cancelToken: cancelToken.token, }).then((res) => res.data);
}

export function getCardService(params) {
  if (cancelToken) {
    cancelToken.cancel('cancelToken');
  }
  cancelToken = source.source();
  return api.get(getCardURL(), { params, cancelToken: cancelToken.token, }).then((res) => {
    return res.data.result.filter((item) => {
      return item?.number;
    });
  });
}
